import type { Utility } from '../../../types/utility';
import type { Quote } from './index';

const baseBlockquote: Utility.VariantCSSKeys<Quote.Blockquote.VariantKeys> = {
  default: {
    fontSize: 'fs20',
    lineHeight: 'lh1_5',
    color: 'primary',
    fontWeight: 'fw500',
    margin: 's40',
    padding: '0 0 0 20px',
  },
};

const blockquote: Utility.VariantKeyModes<Quote.Blockquote.VariantKeys> = {
  products: {
    chart: baseBlockquote,
    chartblog: baseBlockquote,
    co: baseBlockquote,
    edu: baseBlockquote,
    scale: baseBlockquote,
    spark: baseBlockquote,
  },
};

export const blockquoteVariants = Object.keys(blockquote) as Quote.Blockquote.VariantKeys[];

export default blockquote;
